const pathsKey = "paths";

function getPathsArray() {
    let pathsArr = [];

    let paths = localStorage.getItem(pathsKey);
    if(paths) {
        pathsArr = paths.split(",");
    }

    return pathsArr;
}

export function saveHistory() {
    let bodyEl = document.querySelector("body");
    let currentPath = bodyEl.dataset.path;

    if(currentPath.length < 1) {
        return null;
    }

    let previousPath = getCurrentPath();
    if(previousPath === currentPath) {
        return null;
    }

    let pathsArr = getPathsArray();

    if(pathsArr.length > 3) {
        pathsArr.shift();
    }

    pathsArr.push(currentPath);

    localStorage.setItem(pathsKey, pathsArr);
}

export function getCurrentPath() {
    let pathsArr = getPathsArray();

    if(!pathsArr) {
        return null;
    }

    return pathsArr[pathsArr.length - 1];
}

export function getPreviousPath() {
    let pathsArr = getPathsArray();

    if(!pathsArr) {
        return null;
    }

    return pathsArr[pathsArr.length - 2];
}